<script setup>
/**
 * FormControlContentTitle
 * Replaces 'extends: FormControlTypeText' with Composition.
 * Sets the field as 'required' only when not in Page Editor mode.
 */
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormControlTypeText from "../form-control-type/FormControlTypeText.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const pageEditorMode = computed(() => store.state.pageEditorMode);

// --- Lifecycle ---

onMounted(() => {
    /**
     * Logic: If we are in the page editor, titles might be optional
     * or handled differently, otherwise they are mandatory.
     */
    props.field.required = !pageEditorMode.value;
});
</script>

<template>
    <FormControlTypeText
        ref="baseControl"
        v-bind="$props"
        v-on="$listeners"
    />
</template>